import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ComingSoon = () => {
  const { game } = useParams();
  const navigate = useNavigate();
  
  // Format game name from URL parameter
  const formatGameName = (name) => {
    if (!name) return "This Game";
    return name
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  
  const gameName = formatGameName(game);
  
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <div className="text-center max-w-2xl mx-auto p-8 bg-gray-800 rounded-lg shadow-lg">
        <div className="text-6xl mb-6">🎲</div>
        <h2 className="text-3xl font-bold mb-4">{gameName} Coming Soon</h2>
        <p className="text-lg mb-6">
          We're currently developing this exciting new game for our casino. 
          Check back soon to experience all the thrills and rewards!
        </p>
        <div className="bg-gray-700 p-4 rounded-lg mb-6">
          <p className="text-yellow-400 font-semibold">Be the first to play!</p>
          <p className="text-gray-400">Join our newsletter to get notified when new games launch</p>
        </div>
        <button 
          onClick={() => navigate('/casino')}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full transition duration-300"
        >
          Back to Casino
        </button>
      </div>
    </div>
  );
};

export default ComingSoon;
